import Cookies from 'js-cookie';

/**
 * Gets the device ID from the deviceId cookie.
 * The cookie is set by the Ember device-manager service on app initialization.
 *
 * @returns The device ID if the cookie exists, undefined otherwise
 */
export function getDeviceId(): string | undefined {
  return Cookies.get('deviceId');
}
